import CryptoJS from 'crypto-js'

const aesKey = '748521560af141f7ab458a6cc98d89f4'
const aesIv = '4516a117b5ac9d94'

export function encrypt(plains, key, iv) {
  const k = CryptoJS.enc.Utf8.parse(key || aesKey)
  const i = CryptoJS.enc.Utf8.parse(iv || aesIv)
  return CryptoJS.AES.encrypt(plains, k, { iv: i }).toString()
}

export function decrypt(cipher, key, iv) {
  const k = CryptoJS.enc.Utf8.parse(key || aesKey)
  const i = CryptoJS.enc.Utf8.parse(iv || aesIv)
  return CryptoJS.AES.decrypt(cipher, k, { iv: i }).toString(CryptoJS.enc.Utf8)
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function encryptRequest(request) {
  const param = request.param
  if (param) {
    const plains = JSON.stringify(param)
    const cipher = encrypt(plains)
    request.param = cipher
  }
  return request
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function decryptResponse(response) {
  const cipher = response.data
  if (cipher) {
    const plains = decrypt(cipher)
    const data = JSON.parse(plains)
    response.data = data
  }
  return response
}

export function sign(cipher) {
  return CryptoJS.SHA256(cipher).toString()
}

const security = {
  aesKey,
  aesIv,
  encrypt,
  decrypt,
  encryptRequest,
  decryptResponse,
  sign
}

export default security
